export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-291e58a0aa854d90fded09edb13d363d.svg";